export const FRONTEND_ROUTES_KEYS = {
  SESSION_ID: ':sessionId',
  SELECTED_SESSION: 'selectedSession',
  MEDIA_UUID: ':mediaUuid',
  USER_UUID: ':userUuid',
  ORG_UUID: ':orgUuid',
  USER_PREFERENCES: 'user-preferences',
  PRIVACY_DATA: 'privacy-data',
  LICENSE: 'license',
} as const;

/** Query key for organization detail tabs: `/organization-management/:orgUuid?tab=users` */
export const ORGANIZATION_MANAGEMENT_TAB_QUERY_KEY = 'tab';

export const ORGANIZATION_MANAGEMENT_TAB = {
  OVERVIEW: 'overview',
  USERS: 'users',
  LICENSES: 'licenses',
} as const;

export type OrganizationManagementTab =
  (typeof ORGANIZATION_MANAGEMENT_TAB)[keyof typeof ORGANIZATION_MANAGEMENT_TAB];

export const FRONTEND_ROUTE_SEARCH_PARAMS = {
  share: 'share',
} as const;

const FRONTEND_ROUTES = {
  HOME: '/',
  AUTH_CALLBACK: '/auth/callback',
  DASHBOARD: '/dashboard',
  COMPLETE_PROFILE: '/complete-profile',
  USER_SESSIONS: `/sessions/${FRONTEND_ROUTES_KEYS.SESSION_ID}?`,
  SESSION: '/session/:channelId',
  PROFILE: '/profile',
  PROFILE_LICENSE: '/profile/license',
  USER_PREFERENCES: `/profile/${FRONTEND_ROUTES_KEYS.USER_PREFERENCES}`,
  PRIVACY_DATA: `/profile/${FRONTEND_ROUTES_KEYS.PRIVACY_DATA}`,
  // BILLING: '/profile/billing',
  // NOTIFICATIONS: '/profile/notifications',
  PRIVACY_POLICY: '/privacy-policy',
  SELF_USER_MANAGEMENT: '/user-management',
  INDEPENDENT_USER_MANAGEMENT: '/independent-user-management',
  LICENSE_MANAGEMENT: '/license-management',
  USER_DETAILS: `/user/${FRONTEND_ROUTES_KEYS.USER_UUID}`,
  MY_MEDIA: `/media/${FRONTEND_ROUTES_KEYS.MEDIA_UUID}?`,
  ORGANIZATION_MANAGEMENT: '/organization-management',
  ORGANIZATION_MANAGEMENT_DETAIL:
  `/organization-management/${FRONTEND_ROUTES_KEYS.ORG_UUID}`,
  ORGANIZATION_SETTINGS: '/organization-settings',
} as const;

export const FRONTEND_SEARCH_PARAMS_KEYS = {
  SESSIONS_DASHBOARD: {
    MODE: {
      KEY: 'mode',
      CALENDAR: 'calendar',
      TABLE: 'table',
    },
    SELECTED_DATE: 'selectedDate',
  },
} as const;

export default FRONTEND_ROUTES;
